import React, { createContext, useState, useContext, useEffect } from 'react';

const ContentContext = createContext();

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within ContentProvider');
  }
  return context;
};

const defaultContent = {
  ar: {
    siteName: 'الرشيد للحاسبات',
    tagline: 'حلول تقنية متكاملة في بريدة',
    heroTitle: 'مرحباً بك في الرشيد للحاسبات',
    heroSubtitle: 'أفضل خدمات بيع وإصلاح أجهزة الكمبيوتر في بريدة، القصيم',
    heroDescription: 'في قلب بريدة، نقدم لك أفضل حلول تقنية متكاملة. نوفر أحدث أجهزة الكمبيوتر المكتبية والمحمولة، وأجهزة الألعاب عالية الأداء المصممة خصيصاً لعشاق الألعاب. مع خدمات إصلاح وصيانة احترافية سريعة، نحن الخيار الأول لأهالي بريدة ومنطقة القصيم. تقييم 4.5 نجوم من عملائنا الكرام يعكس التزامنا بالجودة والخدمة المتميزة.',
    ctaButton: 'استكشف خدماتنا',
    gamingTitle: 'أجهزة الألعاب المخصصة',
    gamingSubtitle: 'قم ببناء حاسوب أحلامك للألعاب',
    gamingDescription: 'هل تبحث عن أفضل أجهزة الألعاب في بريدة؟ نحن متخصصون في بناء أجهزة الألعاب المخصصة بأحدث المعالجات من Intel وAMD، والبطاقات الرسومية من NVIDIA وAMD Radeon. سواء كنت تبحث عن جهاز للمنافسة في الألعاب الإلكترونية أو للاستمتاع بأحدث الألعاب بدقة 4K، نحن هنا لمساعدتك في بناء حاسوب أحلامك. جميع أجهزتنا مضمونة ومختبرة لضمان الأداء الأمثل.',
    whyTitle: 'لماذا الرشيد للحاسبات؟',
    whySubtitle: 'نحن الخيار الأمثل لاحتياجاتك التقنية',
    whyPoints: [
      {
        title: 'خبرة 4.5 نجوم في بريدة',
        description: 'تقييم ممتاز من مئات العملاء الراضين في بريدة ومنطقة القصيم. نحن فخورون بسمعتنا كأفضل متجر للحاسبات في المنطقة.'
      },
      {
        title: 'خدمة إصلاح سريعة',
        description: 'إصلاح وصيانة سريعة لجميع أنواع الأجهزة. معظم الإصلاحات تتم في نفس اليوم. خدمة منزلية متاحة لأهالي بريدة.'
      },
      {
        title: 'أسعار تنافسية في القصيم',
        description: 'أفضل الأسعار في السوق المحلي مع ضمان الجودة. نقدم عروض خاصة على أجهزة الألعاب والأجهزة المكتبية.'
      },
      {
        title: 'دعم فني متخصص 24/7',
        description: 'فريق محترف من الفنيين جاهز لمساعدتك في أي وقت. استشارات مجانية قبل الشراء وخدمة ما بعد البيع متميزة.'
      }
    ],
    servicesTitle: 'خدماتنا',
    servicesSubtitle: 'خدمات كمبيوتر احترافية مدعومة بخبرة سنوات وفنيين معتمدين',
    services: [
      { icon: 'repair', title: 'إصلاح الكمبيوتر', description: 'تشخيص وإصلاح احترافي لجميع مشاكل الهاردوير والسوفتوير. ضمان سرعة التنفيذ.' },
      { icon: 'dataRecovery', title: 'استعادة البيانات', description: 'خدمات استعادة بيانات احترافية للأقراص التالفة والملفات المحذوفة والأنظمة المعطلة.' },
      { icon: 'performance', title: 'ترقية الأداء', description: 'عزّز سرعة جهازك بترقية الذاكرة وتركيب SSD والتحسينات.' },
      { icon: 'virus', title: 'إزالة الفيروسات', description: 'إزالة كاملة للبرمجيات الخبيثة والفيروسات مع تعزيز أمان النظام.' },
      { icon: 'customBuilds', title: 'تجميع مخصص', description: 'تجميع احترافي لأجهزة مخصصة للألعاب أو العمل أو التطبيقات المتخصصة.' },
      { icon: 'diagnostics', title: 'تشخيص النظام', description: 'فحص شامل للهاردوير والسوفتوير لتحديد المشاكل ومنعها.' }
    ],
    premiumLaptopsTitle: 'لابتوبات مميزة',
    premiumLaptopsSubtitle: 'لابتوبات مستعملة وجديدة بجودة عالية وأسعار منافسة. جميع الأجهزة مختبرة ومعتمدة.',
    buildPcTitle: 'اصنع جهاز الألعاب الخاص بك',
    buildPcSubtitle: 'خصص جهاز أحلامك بمكونات مميزة. التجميع الاحترافي مشمول.',
    interactiveCards: {
      title: 'لماذا نحن الأفضل؟',
      subtitle: 'تعرف على مميزاتنا الفريدة',
      cards: [
        {
          title: 'خبرة وجودة',
          description: 'سنوات من الخبرة في مجال الكمبيوتر والتقنية'
        },
        {
          title: 'أسعار منافسة',
          description: 'أفضل الأسعار مع ضمان الجودة العالية'
        },
        {
          title: 'خدمة سريعة',
          description: 'نقدم خدمات سريعة وفعالة لجميع عملائنا'
        },
        {
          title: 'رضا العملاء',
          description: 'رضا العملاء هو أولويتنا الأولى وأساس نجاحنا'
        }
      ]
    },
    galleryTitle: 'معرض أجهزتنا المخصصة',
    gallerySubtitle: 'تصفح معرض أجهزتنا الرائعة - جرب التمرير على الجوال',
    galleryBuildLabel: 'جهاز مخصص',
    galleryInfo: 'اسحب أو استخدم الأزرار للتنقل',
    galleryImagesAvailable: 'صور متاحة في المعرض',
    galleryShowing: 'يعرض',
    galleryImages: 'صور',
    galleryImage: 'صورة واحدة',
    galleryTwoImages: 'صورتين',
    galleryThreeImages: '3 صور',
    contactTitle: 'اتصل بنا',
    contactSubtitle: 'نحن هنا لمساعدتك',
    contactForm: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      message: 'الرسالة',
      submit: 'إرسال'
    },
    location: 'بريدة، منطقة القصيم، المملكة العربية السعودية',
    owner: 'عبدالله',
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      admin: 'لوحة التحكم'
    }
  },
  en: {
    siteName: 'Al-Rasheed Computers',
    tagline: 'Complete IT Solutions in Buraidah',
    heroTitle: 'Welcome to Al-Rasheed Computers',
    heroSubtitle: 'Best Computer Sales & Repair Services in Buraidah, Al-Qassim',
    heroDescription: 'Located in the heart of Buraidah, we offer complete IT solutions for residents of Al-Qassim Province. We provide the latest desktop and laptop computers, high-performance custom gaming PCs designed for gaming enthusiasts, and professional fast repair services. Our 4.5-star rating from valued customers reflects our commitment to quality and excellent service.',
    ctaButton: 'Explore Our Services',
    gamingTitle: 'Custom Gaming PCs',
    gamingSubtitle: 'Build Your Dream Gaming Computer',
    gamingDescription: 'Looking for the best gaming PCs in Buraidah? We specialize in building custom gaming computers with the latest Intel and AMD processors, and NVIDIA and AMD Radeon graphics cards. Whether you need a PC for competitive esports or to enjoy the latest games in 4K resolution, we\'re here to help you build your dream computer. All our systems are guaranteed and tested for optimal performance.',
    whyTitle: 'Why Al-Rasheed Computers?',
    whySubtitle: 'We are the best choice for your IT needs',
    whyPoints: [
      {
        title: '4.5 Star Rating in Buraidah',
        description: 'Excellent rating from hundreds of satisfied customers in Buraidah and Al-Qassim Province. We\'re proud of our reputation as the best computer shop in the region.'
      },
      {
        title: 'Fast Repair Service',
        description: 'Quick repair and maintenance for all types of devices. Most repairs completed same day. Home service available for Buraidah residents.'
      },
      {
        title: 'Competitive Prices in Al-Qassim',
        description: 'Best prices in the local market with quality guarantee. Special offers on gaming PCs and desktop computers.'
      },
      {
        title: 'Expert Technical Support 24/7',
        description: 'Professional team of technicians ready to help you anytime. Free consultations before purchase and excellent after-sales service.'
      }
    ],
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Professional computer services backed by years of experience and certified technicians.',
    services: [
      { icon: 'repair', title: 'Computer Repair', description: 'Expert diagnosis and repair for all hardware and software issues. Fast turnaround guaranteed.' },
      { icon: 'dataRecovery', title: 'Data Recovery', description: 'Professional data recovery services for failed drives, deleted files, and corrupted systems.' },
      { icon: 'performance', title: 'Performance Upgrades', description: 'Boost your system\'s speed with RAM upgrades, SSD installations, and optimization.' },
      { icon: 'virus', title: 'Virus Removal', description: 'Complete malware and virus removal with system security hardening and protection setup.' },
      { icon: 'customBuilds', title: 'Custom Builds', description: 'Professional custom PC assembly for gaming, workstations, and specialized applications.' },
      { icon: 'diagnostics', title: 'System Diagnostics', description: 'Comprehensive hardware and software testing to identify and prevent potential issues.' }
    ],
    premiumLaptopsTitle: 'Premium Laptops',
    premiumLaptopsSubtitle: 'Quality pre-owned and new laptops at unbeatable prices. All devices tested and certified.',
    buildPcTitle: 'Build Your Gaming PC',
    buildPcSubtitle: 'Customize your dream gaming rig with premium components. Professional assembly included.',
    interactiveCards: {
      title: 'Why Choose Us?',
      subtitle: 'Discover our unique advantages',
      cards: [
        {
          title: 'Expertise & Quality',
          description: 'Years of experience in computers and technology'
        },
        {
          title: 'Competitive Prices',
          description: 'Best prices with guaranteed high quality'
        },
        {
          title: 'Fast Service',
          description: 'We provide fast and efficient service to all our customers'
        },
        {
          title: 'Customer Satisfaction',
          description: 'Customer satisfaction is our top priority and the foundation of our success'
        }
      ]
    },
    galleryTitle: 'Our Custom PC Gallery',
    gallerySubtitle: 'Browse our stunning custom builds - Swipe on mobile',
    galleryBuildLabel: 'Custom Build',
    galleryInfo: 'Swipe or use arrows to navigate',
    galleryImagesAvailable: 'images available in gallery',
    galleryShowing: 'Showing',
    galleryImages: 'images',
    galleryImage: 'image',
    galleryTwoImages: '2 images',
    galleryThreeImages: '3 images',
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to help you',
    contactForm: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      submit: 'Submit'
    },
    location: 'Buraidah, Al-Qassim Province, Saudi Arabia',
    owner: 'Abdullah',
    nav: {
      home: 'Home',
      services: 'Services',
      contact: 'Contact',
      admin: 'Admin'
    }
  }
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/content`);
      if (response.ok) {
        const data = await response.json();
        // Merge with defaults to ensure all keys exist
        setContent(prev => ({
          ar: { ...prev.ar, ...data.ar },
          en: { ...prev.en, ...data.en }
        }));
      }
    } catch (error) {
      console.error('Failed to fetch content:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateContent = async (newContent) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/content`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newContent)
      });
      if (response.ok) {
        setContent(newContent);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Failed to update content:', error);
      return false;
    }
  };

  return (
    <ContentContext.Provider value={{ content, setContent, updateContent, loading }}>
      {children}
    </ContentContext.Provider>
  );
};
